<template>

   <div class="container">
       
       
       <div class="row">
           <div class="col-md-8 col-lg-6 col-xs-12">
               <div class="contactForm mx-auto">
                   <div class="title text-left">Contactez nous <a class="btn btn-secondary-outline mx-auto" href="https://discord.gg/t5GE2wTDSk"> Rejoignez notre serveur Discord <i class="fab fa-discord"></i></a></div>

                        <form action="">
                            <div class="form-group">
                                <label class="formLabel"  for="emailContact">Votre adresse email</label>
                                <input  v-model="email" required  type="email" class="form-control" id="emailContact" aria-describedby="emailContact">
                                <!-- <small id="emailContact" class="form-text text-muted">Votre adresse email sera uniquement utilisée dans le but de vous contacter.</small> -->
                            </div>
                            <div class="form-group">
                                <label class="formLabel" for="phoneContact">Votre numéro de téléphone</label>
                                <input  v-model="phone"  type="number" class="form-control" id="phoneContact" aria-describedby="phoneContact">
                                <!-- <small id="phoneContact" class="form-text text-muted">Votre numéro de téléphone sera uniquement utilisé dans le but de vous contacter.</small> -->
                            </div>
                            <div class="form-group">
                                <label class="formLabel" for="emailContact">Votre nom</label>
                                <input  v-model="name" required  type="text" class="form-control" id="nameContact" aria-describedby="nameContact">
                            </div>
                            <div class="form-group">
                                <label class="formLabel" for="contentContact">Votre demande</label>
                                <textarea v-model="content" required class="form-control" name="contentContact" id="contentContact" cols="10" rows="5"></textarea>
                            </div>
                            <button v-on:click="sendSlack()" class="btn btn-primary btn-block">Envoyer</button>
                            <div class="result" v-bind:class="{ 'text-danger': hasError }">{{ result }}</div>
                        </form>
                </div>
           </div>
           <div class="col text-center">
              <div class="imgContact"></div>
           </div>
       </div>
        
       <div class="terms">
                   Les informations recueillies sur ce formulaire vous permettent de recevoir des communications sur nos offres, produits et services ;de répondre à vos demandes de démonstration de nos services et plus largement d’opérer notre mise en contact mutuelle. La fourniture de votre email est nécessaire pour recevoir les communications susmentionnées mais demeure entièrement facultative.
                    La base légale est le consentement ( art. 6.1.a du RGPD). Les destinataires de données sont le responsable de traitement(SAS AgriVitech, RCS Reims 882 706 658) , ses services internes en charge de la gestion de la page contact du site ainsi que toute personne légalement autorisée à accéder aux données. 
                    La durée de traitement des données est limitée au temps pendant lequel vous êtes inscrit à nos services de communication, étant entendu que vous pouvez retirer votre consentement et vous désinscrire à tout moment en nous transmettant une demande par mail à l’adresse privacy@agrivitech.com.
                    Le serveur sur lequel se trouve le site internet www.agrivitech.com est hébergé par AWS en France mais aucune information relative à vos données personnelles n’est transmise lors de votre inscription sur la page contact, lesquelles demeurent exclusivement dans le périmètre de la société AgriVitech. 
                    Par ailleurs, vous disposez du droit de demander au responsable du traitement l’accès à vos données à caractère personnel, la rectification ou l’effacement de celles-ci, ou une limitation du traitement relatif à la personne concernée, ou du droit de s’opposer au traitement et du droit à la portabilité des données. Vous avez également le droit d’introduire une réclamation auprès d’une autorité de contrôle. 

               </div>
   </div>
   
</template>

<script >
import axios from 'axios'


export default {
    name: 'contactUs',
    data(){
      return {
        email: null,
        phone:null,
        name:null,
        content:null,
        result:null,
        hasError:false
      }
    },

    methods: {
  
      sendSlack(){
        if (!this.email || !this.phone || !this.name || !this.content) {
            this.hasError = true
            this.result = 'Merci de renseigner tous les champs demandés pour envoyer votre demande'
        } else {
            axios.post('https://discord.com/api/webhooks/1122785755010433055/si9x3PtsXp0MndS8sqYSEQQbk6Z9WPyEVfmXUpAfg_coLbC1YZ_S9b74pacb_1anEIga', {content: "Nouvelle demande de contact de "+this.name+" (" + this.email + " - " + this.phone +") : " + this.content})
            this.hasError = false
            this.result = 'Votre demande de contact a bien été enregistrée'
        }

      }
    }
    
}
</script>

<style lang="scss" scoped>


.formLabel{
    font-size: 20px;
    font-weight: 600;
}
.contactForm{
    max-width: 500px;
}
.imgContact{
    background-image: url('../assets/img/contactezNous.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 100%;
}
.terms{
    font-size: 12px;
    color: grey;
    margin: 80px 0px;
    text-align: justify;
}
.result {
    font-weight: 600;
    margin-top: 10px;
    color: var(--mainGreen);
}

</style>